import i18n from 'i18next'
import ChainedBackend from 'i18next-chained-backend'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

const isBrowser = typeof window !== 'undefined'

const isTestEnv = import.meta.env.NODE_ENV === 'test' || import.meta.env.VITEST
import packageJson from '../package.json'
const version = packageJson.version

if (!isTestEnv) {
  i18n
    .use(ChainedBackend)
    .use(initReactI18next)
    .init({
      backend: {
        backends: [HttpBackend],
        backendOptions: [
          {
            loadPath: `${import.meta.env.BASE_URL}locales/{{lng}}/{{ns}}.json?v=${version}`
          },
          {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
            initImmediate: false
          }
        ]
      },

      lng: 'de',
      fallbackLng: 'de',
      defaultNS: 'common',

      ns: [
        'ai',
        'attorney',
        'auth',
        'billing',
        'caseProperty',
        'casesOverview',
        'chart1',
        'chart2',
        'chart3',
        'chart4',
        'chart5',
        'closing',
        'collisionDetection',
        'common',
        'contact',
        'dashboard',
        'documentationList',
        'editorView',
        'firstContact',
        'forwardRightmart',
        'furtherCases',
        'incomingCall',
        'messageToM2',
        'notice',
        'processingProperty',
        'reportProperty',
        'requestCoverage',
        'sms',
        'table',
        'userProfile',
        'validation',
        'payment',
        'feedbacks',
        'payouts',
        'requestedInfo',
        'einsatzplanung',
        'suggestedAgents'
      ],
      partialBundledLanguages: true,

      debug: import.meta.env.VITE_ENV,
      interpolation: { escapeValue: false },

      initImmediate: isBrowser
    })
}

export default i18n
